const publicUrls = ['/emergency-contact-'];

export const isPublicUrl = (pathname: string) => {
  return publicUrls.some((path) => pathname.startsWith(path));
};
